import React from "react";

const TicketIcon = ({ size = 64, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <linearGradient id="ticketGradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ff6a00" />
          <stop offset="50%" stopColor="#ffcc00" />
          <stop offset="100%" stopColor="#ff0066" />
        </linearGradient>
      </defs>

      <path
        d="M10 16 h44 a2 2 0 0 1 2 2 v8 a6 6 0 0 0 0 12 v8 a2 2 0 0 1-2 2 H10 a2 2 0 0 1-2-2 v-8 a6 6 0 0 0 0-12 v-8 a2 2 0 0 1 2-2 z"
        fill="url(#ticketGradient)"
        stroke="#333"
        strokeWidth="2"
        rx="4"
        ry="4"
      />

      {/* Decorative perforation line */}
      <line
        x1="32"
        y1="16"
        x2="32"
        y2="48"
        stroke="white"
        strokeWidth="2"
        strokeDasharray="4 4"
      />

      {/* Small star for flair */}
      <polygon
        points="32,24 34,28 38,28 35,31 36,35 32,33 28,35 29,31 26,28 30,28"
        fill="white"
      />
    </svg>
  );
};

const PurchaseIcon = ({ size = 64, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <linearGradient id="bagGradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#4facfe" />
          <stop offset="50%" stopColor="#00f2fe" />
          <stop offset="100%" stopColor="#43e97b" />
        </linearGradient>
      </defs>

      {/* Bag body */}
      <path
        d="M16 20 h32 a2 2 0 0 1 2 2 v28 a4 4 0 0 1-4 4 H18 a4 4 0 0 1-4-4 V22 a2 2 0 0 1 2-2 z"
        fill="url(#bagGradient)"
        stroke="#333"
        strokeWidth="2"
        rx="4"
        ry="4"
      />

      {/* Bag handle */}
      <path
        d="M24 20a8 8 0 0 1 16 0"
        fill="none"
        stroke="#333"
        strokeWidth="2"
      />

      {/* Checkmark (purchase complete) */}
      <path
        d="M26 38 l6 6 12-14"
        fill="none"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// StructureIcon.jsx
// SVG-only React component representing a greenhouse/polyhouse/nethouse structure.
// Props: size (number, default 64), className (string)

// StructureIcon.jsx
// A colorful greenhouse/polyhouse/nethouse structure icon.
// Props: size (number, default 64), className (string)

const StructureIcon = ({ size = 64, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Structure icon"
    >
      <defs>
        {/* Gradients for frame and glass */}
        <linearGradient id="glassGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#a1e3ff" />
          <stop offset="50%" stopColor="#d0f0ff" />
          <stop offset="100%" stopColor="#b3ecff" />
        </linearGradient>
        <linearGradient id="frameGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#6d28d9" />
          <stop offset="100%" stopColor="#3b82f6" />
        </linearGradient>
        <linearGradient id="groundGrad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#34d399" />
          <stop offset="100%" stopColor="#10b981" />
        </linearGradient>
        <radialGradient id="sunGrad" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#fffb96" />
          <stop offset="100%" stopColor="#ffcc00" />
        </radialGradient>
      </defs>

      {/* Base ground */}
      <rect x="4" y="50" width="56" height="6" rx="2" fill="url(#groundGrad)" />

      {/* Structure frame */}
      <g
        stroke="url(#frameGrad)"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 46 V22 L32 8" />
        <path d="M52 46 V22 L32 8" />
        <path d="M12 46 H52" />
        <path d="M22 46 V22" />
        <path d="M32 46 V22" />
        <path d="M42 46 V22" />
        <path d="M18 18 H46" />
      </g>

      {/* Glass panels */}
      <g fill="url(#glassGrad)" stroke="#60a5fa" strokeWidth="1">
        <path d="M12 46 L32 8 L12 46 Z" opacity="0.95" />
        <path d="M52 46 L32 8 L52 46 Z" opacity="0.95" />
        <path d="M12 46 H22 V22 L12 46 Z" opacity="0.85" />
        <path d="M22 46 H32 V22 L22 46 Z" opacity="0.9" />
        <path d="M32 46 H42 V22 L32 46 Z" opacity="0.9" />
        <path d="M42 46 H52 V22 L42 46 Z" opacity="0.85" />
      </g>

      {/* Plants inside */}
      <g
        fill="none"
        stroke="#059669"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 44 C18 38, 22 36, 22 32" />
        <path d="M20 40 C18 38, 16 36, 18 34" />
        <path d="M30 44 C30 36, 34 34, 34 28" />
        <path d="M32 39 C30 36, 28 34, 30 32" />
        <path d="M46 44 C46 38, 42 36, 42 32" />
        <path d="M44 40 C46 38, 48 36, 46 34" />
      </g>

      {/* Decorative sun */}
      <circle cx="48" cy="12" r="7" fill="url(#sunGrad)" />
    </svg>
  );
};

// CeaNvphPricingIcon.jsx
// Single-symbol React icon for "CEA NVPH PRICING".
// Props: size (number), className (string), title (string)

function CeaNvphPricingIcon({
  size = 64,
  className = "",
  title = "CEA NVPH Pricing",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <defs>
        <radialGradient id="coinGrad" cx="50%" cy="40%" r="60%">
          <stop offset="0%" stopColor="#fff7cc" />
          <stop offset="100%" stopColor="#f59e0b" />
        </radialGradient>
      </defs>

      {/* Single symbol: stylized coin with rupee sign */}
      <circle
        cx="32"
        cy="32"
        r="20"
        fill="url(#coinGrad)"
        stroke="#fbbf24"
        strokeWidth="2"
      />
      <path
        d="M26 26 H38 M26 30 H36.5 C34.5 32.5 31 34 28 34 L36 38"
        fill="none"
        stroke="#7c2d12"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { TicketIcon, PurchaseIcon, StructureIcon, CeaNvphPricingIcon };
